import { render, staticRenderFns } from "./SeeAllPlans.vue?vue&type=template&id=745a3454&"
import script from "./SeeAllPlans.vue?vue&type=script&lang=js&"
export * from "./SeeAllPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports